import { accountsHttpClient } from '../utils/accountsHttpClient';
import { AuthMapper } from './mapper';

interface ISignInDTO {
	email: string;
	password: string;
}

class AuthService {
	async signIn({ email, password }: ISignInDTO) {
		const body = `${email}:${password}`;
		const encodedBody = btoa(body);

		const { data } = await accountsHttpClient.post(
			'/auth',
			{},
			{
				headers: {
					Authorization: `Basic ${encodedBody}`
				}
			}
		);

		return AuthMapper.toDomain(data);
	}
}

export default new AuthService();
